import type { SortTypes } from '@web-platform/shared-universal-constants/src/sort';
import type { ChangeSortAction } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export const SORT_SELECTED = 'SORT_SELECTED';

export const sortSelected = (order: SortTypes): ChangeSortAction => ({
  type: SORT_SELECTED,
  payload: {
    order,
  },
});
